import { createApp } from "vue";
import App from "./App.vue";

import "./styles/styles.css";

import store from "./store";

createApp(App).use(store).mount("#knaufDuebelrechner");
